import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AccountService } from '../../../../services/account.service';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexNoData,
  ApexStroke,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DrowpdownFilterHandler } from '../../../../utils/utils';
import { ResearchPortalBdService } from '../../../../services/research-portal-bd.service';
import * as moment from 'moment';
export interface ChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  yaxis: ApexYAxis;
  legend: ApexLegend;
  fill: ApexFill;
  stroke: ApexStroke;
  markers: ApexMarkers;
  colors: string[];
  noData: ApexNoData;
  tooltip: ApexTooltip;
  grid: ApexGrid;
}

@Component({
  selector: 'app-stock-overview',
  templateUrl: './stock-overview.component.html',
  styleUrls: ['./stock-overview.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockOverviewComponent implements OnInit, OnChanges {
  @Input() selectedCompany;
  @Output() sparkLineData = new EventEmitter<any>();
  @Input() companyList;
  @Input() chartIndex;
  @Input() sharePrice;
  graphDataSet = [];
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions1: Partial<ChartOptions>;
  companyOverviewSummaryGraphFG: FormGroup;
  compareWithCompany = [];
  compareWithIndices = [];

  selectedCompCompany: any;
  selectedCompIndex: any;
  filteredCompanyList: any;
  companyFilteredListMaster: any;
  companyListMaster = [];
  chartIndexTypesMaster: any;
  chartIndexTypes = [
    { name: 'DSEX', type: 'index' },
    { name: 'DSES', type: 'index' },
    { name: 'DS30', type: 'index' },
  ];
  selectedDuration = '1M';
  handleCompanyFilter = DrowpdownFilterHandler.bind(this)('companyFilteredListMaster', 'filteredCompanyList', 'companyName');
  handlecomparisonIndexFilter = DrowpdownFilterHandler.bind(this)('chartIndexTypesMaster', 'chartIndexTypes');

  get selectedGraphs() {
    return [...this.compareWithCompany, ...this.compareWithIndices];
  }
  darkMode;
  constructor(
    private cdRef: ChangeDetectorRef,
    private researchPortalService: ResearchPortalBdService,
    private fb: FormBuilder,
    private accountService: AccountService
  ) {
    this.companyOverviewSummaryGraphFG = this.fb.group({
      comparisonCompany: [],
      comparisonIndex: [],
    });
  }

  ngOnInit() {
    // this.accountService.switchTheme.subscribe((themeMode) => {
    //   if (themeMode !== null) {
    //     this.darkMode = themeMode;
    //     this.generateChart();
    //     this.cdRef.detectChanges();
    //   }
    // });
    this.companyOverviewSummaryGraphFG.get('comparisonCompany').valueChanges.subscribe(async (value) => {
      if (value && value.companyName != null) {
        if (this.compareWithCompany.indexOf(value) === -1) {
          this.compareWithCompany.push(value);
          // this.researchPortalService.emitCompareCompany(this.compareWithCompany);
          this.companyOverviewSummaryGraphFG.get('comparisonCompany').setValue(null);
          await this.getCompanyData();
        }
      }
    });

    this.companyOverviewSummaryGraphFG.get('comparisonIndex').valueChanges.subscribe(async (value) => {
      if (value && value.name != null) {
        if (this.compareWithIndices.indexOf(value) === -1) {
          this.compareWithIndices.push(value);
          if (value.name != null) {
            this.companyOverviewSummaryGraphFG.get('comparisonIndex').setValue(null);
            await this.getCompanyData();
          }
        }
      }
    });
    this.generateChart([]);
    this.accountService.emitChange.subscribe((status) => {
      if (status != null && this.graphDataSet && this.graphDataSet.length > 0) {
        this.generateChart([]);
        setTimeout(() => {
          this.generateChart(this.graphDataSet);
        }, 10);

        // this.cdRef.detectChanges();
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    // if (this.selectedCompany && this.companyList && this.chartIndex && this.sharePrice) {
    if (this.selectedCompany && this.companyList && this.sharePrice) {
      this.companyListMaster = this.companyList;
      // console.log(this.companyList)
      this.filteredCompanyList = this.companyListMaster;
      this.companyFilteredListMaster = [...this.companyListMaster];
      // this.chartIndexTypesMaster = this.chartIndex;
      // this.chartIndexTypes = this.chartIndexTypesMaster;
      await this.getCompanyData();
    }
    // if (this.companyList) {
    // }
  }

  async getCompanyData() {
    this.graphDataSet = [];
    this.filteredCompanyList = [];
    this.companyListMaster.map((item) => {
      let notSelItem = this.compareWithCompany.find((selItem) => selItem.companyName === item.companyName);
      if (notSelItem === undefined && item.companyName !== this.selectedCompany.companyName) {
        this.filteredCompanyList.push(item);
      }
    });

    let enableBase =
      (this.selectedCompany && (this.compareWithCompany.length !== 0 || this.compareWithIndices.length !== 0) && true) || false;
    let graphDataSet = [];

    if (this.selectedCompany) {
      let gData = await this.researchPortalService.getVWPMetric(this.selectedCompany.companyName, this.selectedDuration, enableBase);
      let data = [];
      gData.forEach((d) => {
        if (d.x && d.y) {
          data.push(d);
        }
      });
      graphDataSet.push({
        data: data.length > 0 ? data : [],
        name: this.selectedCompany.companyName,
        companyId: this.selectedCompany.companyName,
        color: '#0D9488',
      });
      for (let i = 0; i < this.compareWithCompany.length; i++) {
        let comparisonCompany = this.compareWithCompany[i];
        if (comparisonCompany) {
          let cData = await this.researchPortalService.getVWPMetric(comparisonCompany.companyName, this.selectedDuration, enableBase);
          let data1 = [];
          cData.forEach((d) => {
            if (d.x && d.y) {
              data1.push(d);
            }
          });
          graphDataSet.push({
            data: data1.length > 0 ? data1 : [],
            name: comparisonCompany.companyName,
            companyId: comparisonCompany.id,
            color: graphDataSet.length === 1 ? '#F59E0B' : '#' + Math.floor(Math.random() * 16777215).toString(16),
          });
        }
      }

      for (let i = 0; i < this.compareWithIndices.length; i++) {
        let comparisonIndex = this.compareWithIndices[i];
        if (comparisonIndex) {
          let iData = await this.researchPortalService.getIndexValurMatrix(comparisonIndex.name, this.selectedDuration, enableBase);
          let data2 = [];
          iData.forEach((d) => {
            if (d.x && d.y) {
              data2.push(d);
            }
          });
          graphDataSet.push({
            data: data2.length > 0 ? data2 : [],
            name: comparisonIndex.name,
            color: graphDataSet.length === 1 ? '#F59E0B' : '#' + Math.floor(Math.random() * 16777215).toString(16),
          });
        }
      }
      this.graphDataSet = graphDataSet;
      this.generateChart(this.graphDataSet);
      this.sparkLineData.emit(this.graphDataSet[0]);
      this.cdRef.detectChanges();
    }
  }

  async durationChanged(duration) {
    if (this.selectedDuration !== duration) {
      this.selectedDuration = duration;
      await this.getCompanyData();
    }
  }

  async removeSelectedGraph(graphItem) {
    if (graphItem.type === 'index' || graphItem.type === 'sector') {
      this.compareWithIndices.splice(this.compareWithIndices.indexOf(graphItem), 1);
    } else {
      this.compareWithCompany.splice(this.compareWithCompany.indexOf(graphItem), 1);
      // this.researchPortalService.emitCompareCompany(this.compareWithCompany);
    }
    await this.getCompanyData();
  }

  generateChart(data) {
    // debugger
    // console.log('genarate')
    this.chartOptions1 = {
      series: data,
      chart: {
        fontFamily: 'Inter, Arial, sans-serif',
        id: 'chart2',
        type: 'line',
        height: 350,

        toolbar: {
          autoSelected: 'pan',
          show: false,
        },
        redrawOnWindowResize: true,
        redrawOnParentResize: true,
        events: {
          mounted: (chart) => {
            chart.windowResizeHandler();
          },
        },
      },
      stroke: {
        curve: 'straight',
        width: 2,
      },
      tooltip: {
        enabled: true,
        enabledOnSeries: undefined,
        fixed: {
          enabled: false,
          position: 'bottomLeft',
          offsetX: 0,
          offsetY: 0,
        },
        shared: true,
        followCursor: false,
        intersect: false,
        inverseOrder: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          let returnString = '';
          w.globals.initialSeries.forEach((com) => {
            returnString =
              returnString +
              '<div><span class="dot" style="background:' +
              com.color +
              '"></span> <span>' +
              com.name +
              ':</span> <b><span>' +
              Number(com.data[dataPointIndex]?.y || 'N/A').toFixed(2) +
              '</span></b></div>';
          });
          let data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
          data.x = moment(data.x).format('MM/DD/YYYY');
          return '<div class="tootTipBox"><b>' + data.x + ' </b>' + returnString + '</div>';
        },

        fillSeriesColor: false,
        x: {
          show: true,
          format: 'dd-MM-yy',
          formatter: function (v) {
            return moment(v).format('YYYY-MM-DD');
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        offsetY: 8,
        fontSize: '12px',
        height: 50,
        labels: {
          colors: this.darkMode ? '#bab8c5' : '#374151',
          useSeriesColors: false,
        },
      },
      fill: {
        opacity: 1,
      },
      markers: {
        size: 0,
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd/MM',
          style: {
            colors: this.darkMode ? '#bab8c5' : '#374151',
            fontSize: '14px',
          },
        },
      },
      yaxis: {
        decimalsInFloat: this.sharePrice?.todayClosePrice < 30 ? 2 : 0,
        labels: {
          style: {
            colors: this.darkMode ? '#bab8c5' : '#374151',
            fontSize: '14px',
          },
        },
        tooltip: {
          enabled: true,
          offsetX: 0,
        },
      },
      grid: {
        borderColor: this.darkMode ? '#1e293b' : '#e5e7eb',
      },
    };
    this.cdRef.detectChanges();
  }
}
